import React, { Component } from 'react';
import ParameterErrors from '../errors/ParameterErrors';
import TabInfo from '../ui_core/TabInfo';
import Star from './Star';
import { faBed, faToilet} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropertyBindingFactory from '../mvvm/PropertyBindingFactory';
import enableBindingToOthers from '../mvvm/enableBindingToOthers';
import { faStreetView} from '@fortawesome/free-solid-svg-icons';
import IconButton from './IconButton';
import PlotStatus from '../site/PlotStatus';
const {throwNotProvided}=ParameterErrors;
export default class PlotMoreInformationOverview extends Component {
	constructor(props){
		super(props);
		enableBindingToOthers(this);
		const {removeFavourite, addFavourite, showStreetView}=props;
		this._star = React.createRef();
		this._elementRef = React.createRef();
		this._callbackAddFavourite = addFavourite;
		this._callbackRemoveFavourite = removeFavourite;
		this._callbackShowStreetView = showStreetView;
		this._tabInfo = new TabInfo({title:'Overview', className:'overview-tab'});
		this._handleStarSelectedChanged= this._handleStarSelectedChanged.bind(this);
		this._handlePlotSelectedChanged= this._handlePlotSelectedChanged.bind(this);
		this._ellipsisAbout= this._ellipsisAbout.bind(this);
		this._handleClick= this._handleClick.bind(this);
		this._handleClickShowStreetView = this._handleClickShowStreetView.bind(this);
		this._workBackwardsThroughStringToFindLastCharacterBeforeSpaceIndex= this._workBackwardsThroughStringToFindLastCharacterBeforeSpaceIndex.bind(this);
		this.state ={plot:null, showAll:false, aboutTruncated:null};
	}
	load(site, plot){
			this._firstAboutTruncation=true;	
		this.setState({plot:plot, site:site, aboutTruncated:plot.about, showAll:false, aboutTruncatedWithEllipsisWithEllipsisIfRequired:plot.about});
	}
	get tabInfo(){
		return this._tabInfo;
	}
	_handleStarSelectedChanged(selected){
		if(selected)this._callbackAddFavourite(this.state.plot);
		else this._callbackRemoveFavourite(this.state.plot);
	}
	_handlePlotSelectedChanged(value){
		this._star.current.selected=value;
	}
	
	componentDidUpdate(previousProps, previousState){
		const oldPlot = previousState.plot;
		const newPlot = this.state.plot;
		if(!this.state.showAll)
			this._ellipsisAbout();
		if(oldPlot===newPlot)return;
		//example of using mvvm framework
		this.myBindings.reset();
		PropertyBindingFactory.standard(this, newPlot, 'selected', this._handlePlotSelectedChanged);
	}
	_handleClick(){
		const currentShowAll = this.state.showAll;
		if(currentShowAll)return;
		this.setState({showAll:true, aboutTruncatedWithEllipsisWithEllipsisIfRequired:this.state.plot.about});
	}
	_ellipsisAbout(){
		const element = this._elementRef.current;
		const pixelsOverflowing =  element.scrollHeight - element.clientHeight ;
		const isOverflowing = pixelsOverflowing>0;
		if(!isOverflowing)return;
		let aboutTruncated = this.state.aboutTruncated;
		let indexToChopRemainingWrodOffFrom=aboutTruncated.length-1;
		if(this._firstAboutTruncation){
			const proportionToKeep = element.clientHeight / element.scrollHeight;
			indexToChopRemainingWrodOffFrom = Math.floor((aboutTruncated.length-1)*proportionToKeep);
			this._firstAboutTruncation=false;
		}
		const lastCharacterBeforeSpaceIndex = this._workBackwardsThroughStringToFindLastCharacterBeforeSpaceIndex(indexToChopRemainingWrodOffFrom, aboutTruncated);
		aboutTruncated=aboutTruncated.substr(0, lastCharacterBeforeSpaceIndex+1);
		const aboutTruncatedWithEllipsisWithEllipsisIfRequired=aboutTruncated+'...';
		this.setState({aboutTruncated:aboutTruncated, aboutTruncatedWithEllipsisWithEllipsisIfRequired:aboutTruncatedWithEllipsisWithEllipsisIfRequired});
	}
	_workBackwardsThroughStringToFindLastCharacterBeforeSpaceIndex(index, str){
			while(str[index]!==' '&&index>0){
				index--;
			}
			return index-1;
	}
	_handleClickShowStreetView(){
		this._callbackShowStreetView({nearPlot:this.state.plot});
	}
	/*
							<div className="n-of-typed-rooms">
								<FontAwesomeIcon icon={faToilet}></FontAwesomeIcon>
									{this.state.plot?.nBathrooms}
							</div>
							*/
	render(){
		let className = "plot-more-information-overview";
		className+=this.state.showAll?" show-all":" show-limited";
		const hasPrice = (this.state.plot)&&this.state.plot.isAvailable;//(this.state.plot)&&!this.state.plot.isSold;
		return (<div
		className={className}
		onClick={this._handleClick} ref={this._elementRef}>
					<img className="overview-image" src={this.state.plot?.getPlotImageAbsolutePath(this.state.site)}></img>
					<div className="overview-header">
						<div className="name">{this.state.plot?.name}
							<Star onSelectedChange={this._handleStarSelectedChanged} ref={this._star}></Star>
							<IconButton className="button-show-street-view" faIcon={faStreetView} text="" onClick={this._handleClickShowStreetView}></IconButton>
						</div>
						<div className="about-plot">
							<div className="number">Plot {this.state.plot?.number}</div>
							<div className="status"> {this.state.plot? ' - '+PlotStatus.getDescription(this.state.plot.status)+(hasPrice?' - ':''):' - '}</div>
							<div className="price"> {!hasPrice?'':this.state.plot.priceString}</div>
						</div>
						<div className="n-of-typed-roomss">
							<div className="n-of-typed-rooms">
								<FontAwesomeIcon icon={faBed}></FontAwesomeIcon>
									{this.state.plot?.nBedrooms}
							</div>
						</div>
						<br/>			
					</div>
					{this.state.aboutTruncatedWithEllipsisWithEllipsisIfRequired}
				</div>
		)
	}
}
